import { useEffect, useRef, useState } from 'react';
import { FileButton, Text, UnstyledButton } from '@mantine/core';
import { IconPhotoOff, IconPencil } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { prepareQuotePhotos, type QuotePhoto } from './QuoteImageGallery';

type Props={photo:QuotePhoto|null;onChange:(photo:QuotePhoto)=>void;onBusyChange?:(busy:boolean)=>void;title?:string;hint?:string;alt?:string;className?:string};
export function QuoteImagePreview({photo,onChange,onBusyChange,title,hint,alt,className}:Props) {
  const {t}=useTranslation();const label=(key:string)=>t(`opportunity.quote.${key}`);
  const [busy,setBusy]=useState(false);const [error,setError]=useState(false);
  const mounted=useRef(true);const uploading=useRef(false);
  useEffect(()=>{mounted.current=true;return()=>{mounted.current=false;if(uploading.current)onBusyChange?.(false);};},[]);
  const imageTitle=title??label('coverImage');const imageHint=hint??label('coverImageOnly');
  return <aside className={`quote-image-preview ${className||'quote-cover-image'}`}>
    {imageTitle&&<Text size="sm" weight={600}>{imageTitle}</Text>}
    <FileButton accept="image/png,image/jpeg,image/webp" onChange={async file=>{
      if(!file)return;setBusy(true);uploading.current=true;onBusyChange?.(true);setError(false);
      try{const [replacement]=await prepareQuotePhotos([file]);if(mounted.current)onChange(replacement);}
      catch{if(mounted.current)setError(true);}finally{uploading.current=false;if(mounted.current){setBusy(false);onBusyChange?.(false);}}
    }}>{props=><UnstyledButton {...props} disabled={busy} className="quote-cover-image-trigger" aria-label={label('replaceImage')}>
      {photo?<img src={photo.url} alt={alt||imageTitle||label('tableImages')}/>:<span className="quote-cover-image-empty"><IconPhotoOff size={28}/></span>}
      <span className="quote-cover-image-action"><IconPencil size={14}/>{label('replaceImage')}</span>
    </UnstyledButton>}</FileButton>
    {imageHint&&<Text size="xs" color="dimmed">{imageHint}</Text>}
    {error&&<Text size="xs" color="red">{label('imageError')}</Text>}
  </aside>;
}
